import { Box, Typography } from "@mui/material";
import BasicRoute from "components/routes/BasicRoute";

export default function RoutesMenusExclusaoDados() {
    return (
        <>
            <BasicRoute
                uid='ExclusaoDados'
                route="exclusao-dados"
                divider
                menuProps={{
                    text: "Conta e Dados",
                    sequence: "600009",
                    iconName: "ManageAccounts",
                }}
                element={<Exclusaodados />}
            />
        </>
    )
}

function Exclusaodados() {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", px: 2 }}>
            <Typography variant="h1" sx={{ fontSize: 34, fontWeight: "bold", textAlign: "center", mt: 4 }}>Exclusão de Conta e Dados / e-Laudo</Typography>
            <Typography variant="h2" sx={{ fontSize: 24, fontWeight: "bold", textAlign: "center", mt: 4 }}>Etapas para realizar a exclusão de conta</Typography>
            <ol>
                <li>Faça o login na sua conta</li>
                <li>Acesse o menu lateral Conta e Dados</li>
                <li>Siga o passo a passo</li>
            </ol>
            <Typography variant="h2" sx={{ fontSize: 24, fontWeight: "bold", textAlign: "center", mt: 4 }}>Tipos de Dados Excluídos</Typography>
            <p>Ao solicitar a exclusão da conta, os seguintes dados serão excluídos permanentemente:</p>
            <ul>
                <li>Informações de perfil (nome, email, etc.)</li>
                <li>Histórico de atividades</li>
                <li>Dados salvos como: visitas, culturas, etc</li>
            </ul>
        </Box>
    )
}